import { Product, ProductDetails } from "./lib/types";

export const headphones: ProductDetails = [
  {
    id: 1,
    name: "XX99 MARK II",
    title: "XX99-MARK-II",
    price: 15500,
    img: "https://i.ibb.co/pJqXzR3/sd.png",
    new: true,
    category: "headphones",
  },
  {
    id: 2,
    name: "MDR-ZX110 Black",
    title: "MDR-ZX1",
    price: 3200,
    img: "https://i.ibb.co/xmhPxfW/hps.png",
    new: false,
    category: "headphones",
  },
  {
    id: 3,
    name: "Anker Life Q30",
    title: "Anker-Life-Q30",
    price: 6800,
    img: "https://i.ibb.co/WGfb0rz/se.png",
    new: false,
    category: "headphones",
  },
  {
    id: 4,
    name: "KVIDIO",
    title: "KVIDIO",
    price: 2700,
    img: "https://i.ibb.co/s1xxW1D/photo-1613040809024-b4ef7ba99bc3-removebg-preview.png",
    new: false,
    category: "headphones",
  },
  {
    id: 5,
    name: "QuietComfort Ultra",
    title: "QuietComfort-Ultra",
    price: 4050,
    img: "https://i.ibb.co/SvfHKTX/photo-1618366712010-f4ae9c647dcb-removebg-preview.png",
    new: false,
    category: "headphones",
  },
  {
    id: 6,
    name: "WH-CH720N Noise Canceling",
    title: "WH-CH720N",
    price: 4500,
    img: "https://i.ibb.co/Wytq7zy/photo-1484704849700-f032a568e944-removebg-preview.png",
    new: false,
    category: "headphones",
  },
];

export const speakers: ProductDetails = [
  {
    id: 7,
    name: "ZX9 SPEAKER",
    title: "ZX9-SPEAKER",
    price: 20000,
    img: "https://i.ibb.co/nzrknWJ/photo-1596457941236-c0611cc87551-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 8,
    name: "ZX7 SPEAKER",
    title: "ZX7-SPEAKER",
    price: 17300,
    img: "https://i.ibb.co/XYdfbm1/spks.png",
    new: false,
    category: "speakers",
  },
  {
    id: 9,
    name: "SSCS5 3-Way",
    title: "SSCS5-3-Way",
    price: 20000,
    img: "https://i.ibb.co/pvGFYJd/premium-photo-1683141496040-eeef9702269f-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 10,
    name: "Edifier R1280DB",
    title: "Edifier-R1280DB",
    price: 14500,
    img: "https://i.ibb.co/f0XD46Y/photo-1589003077984-894e133dabab-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 11,
    name: "HiVi-Swans OS-10 HiFi Stereo",
    title: "HiVi-Swans",
    price: 20500,
    img: "https://i.ibb.co/9p8f8zL/photo-1520860100614-a714deb4805f-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 12,
    name: "Bluetooth Bookshelf Speakers",
    title: "Bluetooth-Bookshelf",
    price: 19000,
    img: "https://i.ibb.co/6X48QxN/photo-1589256469067-ea99122bbdc4-removebg-preview.png",
    new: false,
    category: "speakers",
  },
];

export const earphones: ProductDetails = [
  {
    id: 13,
    name: "YX1 EARPHONES",
    title: "YX1-EARPHONES",
    price: 25500,
    img: "https://i.ibb.co/grVk1Hq/photo-1549400854-b4300f444934-removebg-preview.png",
    new: false,
    category: "earphones",
  },
  {
    id: 14,
    name: "A1 Mini Wireless",
    title: "A1-Mini-Wireless",
    price: 19500,
    img: "https://i.ibb.co/HN6tgSq/eps.png",
    new: false,
    category: "earphones",
  },
  {
    id: 15,
    name: "Raycon Fitness Bluetooth",
    title: "Raycon-Fitness",
    price: 23500,
    img: "https://i.ibb.co/tcG9Q6X/photo-1632247541401-3d4a8d516595-removebg-preview.png",
    new: false,
    category: "earphones",
  },
  {
    id: 16,
    name: "TREBLAB X3 Pro",
    title: "TREBLAB-X3-Pro",
    price: 15000,
    img: "https://i.ibb.co/FshK20P/photo-1587523459887-e669248cf666-removebg-preview.png",
    new: false,
    category: "earphones",
  },
];

export const products: Product = [
  {
    id: 1,
    name: "XX99 MARK II",
    title: "XX99-MARK-II",
    price: 15500,
    img: "https://i.ibb.co/pJqXzR3/sd.png",
    new: true,
    category: "headphones",
  },
  {
    id: 2,
    name: "MDR-ZX110 Black",
    title: "MDR-ZX1",
    price: 3200,
    img: "https://i.ibb.co/xmhPxfW/hps.png",
    new: false,
    category: "headphones",
  },
  {
    id: 3,
    name: "Anker Life Q30",
    title: "Anker-Life-Q30",
    price: 6800,
    img: "https://i.ibb.co/WGfb0rz/se.png",
    new: false,
    category: "headphones",
  },
  {
    id: 4,
    name: "KVIDIO",
    title: "KVIDIO",
    price: 2700,
    img: "https://i.ibb.co/s1xxW1D/photo-1613040809024-b4ef7ba99bc3-removebg-preview.png",
    new: false,
    category: "headphones",
  },
  {
    id: 5,
    name: "QuietComfort Ultra",
    title: "QuietComfort-Ultra",
    price: 4050,
    img: "https://i.ibb.co/SvfHKTX/photo-1618366712010-f4ae9c647dcb-removebg-preview.png",
    new: false,
    category: "headphones",
  },
  {
    id: 6,
    name: "WH-CH720N Noise Canceling",
    title: "WH-CH720N",
    price: 4500,
    img: "https://i.ibb.co/Wytq7zy/photo-1484704849700-f032a568e944-removebg-preview.png",
    new: false,
    category: "headphones",
  },
  {
    id: 7,
    name: "ZX9 SPEAKER",
    title: "ZX9-SPEAKER",
    price: 20000,
    img: "https://i.ibb.co/nzrknWJ/photo-1596457941236-c0611cc87551-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 8,
    name: "ZX7 SPEAKER",
    title: "ZX7-SPEAKER",
    price: 17300,
    img: "https://i.ibb.co/XYdfbm1/spks.png",
    new: false,
    category: "speakers",
  },
  {
    id: 9,
    name: "SSCS5 3-Way",
    title: "SSCS5-3-Way",
    price: 20000,
    img: "https://i.ibb.co/pvGFYJd/premium-photo-1683141496040-eeef9702269f-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 10,
    name: "Edifier R1280DB",
    title: "Edifier-R1280DB",
    price: 14500,
    img: "https://i.ibb.co/f0XD46Y/photo-1589003077984-894e133dabab-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 11,
    name: "HiVi-Swans OS-10 HiFi Stereo",
    title: "HiVi-Swans",
    price: 20500,
    img: "https://i.ibb.co/9p8f8zL/photo-1520860100614-a714deb4805f-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 12,
    name: "Bluetooth Bookshelf Speakers",
    title: "Bluetooth-Bookshelf",
    price: 19000,
    img: "https://i.ibb.co/6X48QxN/photo-1589256469067-ea99122bbdc4-removebg-preview.png",
    new: false,
    category: "speakers",
  },
  {
    id: 13,
    name: "YX1 EARPHONES",
    title: "YX1-EARPHONES",
    price: 25500,
    img: "https://i.ibb.co/grVk1Hq/photo-1549400854-b4300f444934-removebg-preview.png",
    new: false,
    category: "earphones",
  },
  {
    id: 14,
    name: "A1 Mini Wireless",
    title: "A1-Mini-Wireless",
    price: 19500,
    img: "https://i.ibb.co/HN6tgSq/eps.png",
    new: false,
    category: "earphones",
  },
  {
    id: 15,
    name: "Raycon Fitness Bluetooth",
    title: "Raycon-Fitness",
    price: 23500,
    img: "https://i.ibb.co/tcG9Q6X/photo-1632247541401-3d4a8d516595-removebg-preview.png",
    new: false,
    category: "earphones",
  },
  {
    id: 16,
    name: "TREBLAB X3 Pro",
    title: "TREBLAB-X3-Pro",
    price: 15000,
    img: "https://i.ibb.co/FshK20P/photo-1587523459887-e669248cf666-removebg-preview.png",
    new: false,
    category: "earphones",
  },
];

//category : "headphones"
//category : "speakers"
//category : "earphones"
